import { fmt } from "@/lib/api";
import { cn } from "@/lib/utils";

export const approxText = (usd, fx) => (fx?.rate && fx.currency !== "USD" ? `approx. ${fmt(Number(usd || 0) * fx.rate, fx.currency)}` : null);

export function UsdPrice({ amount, fx, suffix, placeholder, className, testId, size = "lg" }) {
  if (placeholder) return <div className="text-sm font-medium text-amber-700" data-testid={testId}>Price coming soon</div>;
  const ap = approxText(amount, fx);
  return (
    <div className={className} data-testid={testId}>
      <div className={cn("font-bold tabular-nums text-[#13294B]", size === "lg" ? "text-2xl" : "text-sm")}>{fmt(amount, "USD")}{suffix && <span className="ml-0.5 text-sm font-normal text-slate-500">{suffix}</span>}</div>
      {ap && <div className="text-xs text-slate-500" data-testid={testId && `${testId}-approx`}>{ap}{suffix ? ` ${suffix}` : ""}</div>}
    </div>
  );
}

export function FxNote({ fx }) {
  if (!fx?.rate || fx.currency === "USD") return null;
  return <p className="text-xs text-slate-500" data-testid="billing-fx-note">PressOps subscriptions are billed and charged in USD. Local amounts are approximate, using today's platform rate of 1 USD ≈ {fx.rate.toLocaleString(undefined, { maximumFractionDigits: 4 })} {fx.currency}{fx.overridden ? " (set manually)" : ""}. Your workspace invoices, quotes, POS and accounting stay in {fx.currency}.</p>;
}
